// AGC: WalletProvider - Conditional provider for Desktop vs BaseApp
// AGC: Desktop: No wallet providers (just children)
// AGC: BaseApp: Full MiniKit + wagmi provider stack

import React, { ReactNode, Suspense, lazy } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getAppContext } from '../hooks/useFeatureFlags'

// AGC: Lazy load BaseApp stack to reduce desktop bundle size
const LazyBaseAppStack = lazy(() => import('./BaseAppStack'))

// AGC: Query client for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // AGC: 5 minutes
      retry: 3,
      refetchOnWindowFocus: true,
    },
  },
})

export interface WalletProviderProps {
  children: ReactNode
}

/**
 * AGC: WalletProvider - Conditionally wraps app with wallet providers
 * AGC: Desktop build: Just QueryClientProvider (no wallet UI)
 * AGC: BaseApp build: Full MiniKit + Frame SDK provider stack
 */
export const WalletProvider: React.FC<WalletProviderProps> = ({ children }) => {
  const context = getAppContext()
  const isBaseAppContext = context === 'baseapp'

  // AGC: BaseApp context - use MiniKit provider stack
  if (isBaseAppContext) {
    console.log('🎯 AGC: BaseApp context detected - enabling MiniKit provider stack')
    return (
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-[#F4F5F7]"><p>Carregando...</p></div>}>
          <LazyBaseAppStack>{children}</LazyBaseAppStack>
        </Suspense>
      </QueryClientProvider>
    )
  }

  // AGC: Desktop context - minimal providers (no wallet UI needed)
  console.log('💻 AGC: Desktop context - no wallet providers needed')
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}







